var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indented-body"},[_c('div',{staticClass:"quote content",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.caption))}})])}
var staticRenderFns = []

export { render, staticRenderFns }